import { FC, useEffect } from 'react';
import { CabinetContainer } from '../../../components/cabinet-container';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { DataTableCard } from '../../../components/data';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTE_CONSTITUTION_CREATE, ROUTE_CONSTITUTION_UPDATE } from '../../../common/constants';
import { useAppDispatch, useAppSelector } from '../../../store';
import { deleteOneConstitution, findAllConstitution } from '../../../features/constitution/thunks';
import { IconDeleteCanOutline, IconSquareEditOutline } from '../../../common/icons';
import { url } from '../../../common/utils';
import { useTranslation } from 'react-i18next';

export const ConstitutionPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { result } = useAppSelector((state) => state.constitution.constitutions);

  const handleRedirect = () => {
    navigate(ROUTE_CONSTITUTION_CREATE);
  };

  const handleDeleteConstitution = async (id: string) => {
    await dispatch(deleteOneConstitution({ id }));
    await dispatch(findAllConstitution());
  };

  useEffect(() => {
    dispatch(findAllConstitution());
  }, [dispatch]);

  return (
    <CabinetContainer>
      <Button onClick={handleRedirect} variant="contained" sx={{ mb: 2, ml: 'auto' }}>
        {t('action.create')}
      </Button>
      <DataTableCard
        columns={[
          {
            dataKey: 'description',
            label: 'constitution.description',
          },
          {
            dataKey: 'redirect_url',
            label: 'constitution.redirect_url',
            renderItem: ({ redirect_url }) => (
              <Typography component={Link} to={redirect_url} target="_blank">
                {redirect_url}
              </Typography>
            ),
          },
          {
            dataKey: '',
            label: 'action.edit',
            renderItem: ({ id }) => (
              <Box component={Link} to={url(ROUTE_CONSTITUTION_UPDATE, { id })}>
                <IconSquareEditOutline />
              </Box>
            ),
          },
          {
            dataKey: '',
            label: 'action.delete',
            renderItem: ({ id }) => (
              <IconButton color="error" onClick={() => handleDeleteConstitution(id)}>
                <IconDeleteCanOutline />
              </IconButton>
            ),
          },
        ]}
        data={result || []}
      />
    </CabinetContainer>
  );
};
